import styled from 'styled-components'

export const Main = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 170px);
  border-top: 1px solid rgba(42, 42, 42, 0.6);
  background-color: #050505;
  background-image:
    linear-gradient(180deg, #111 0%, #080808 28%, #050505 55%, #000 100%),
    linear-gradient(125deg, rgba(120, 188, 40, 0.04) 0%, transparent 40%, rgba(33, 156, 38, 0.03) 100%);
  overflow: visible;
`

export const BackgroundLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
`

export const GlowOrb = styled.div`
  position: absolute;
  top: ${({ $top }) => $top};
  left: ${({ $left }) => $left};
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(
    circle,
    ${({ $color }) => $color} 0%,
    rgba(0, 0, 0, 0) 68%
  );
  filter: blur(40px);
`

export const CatalogContent = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  min-height: 0;
  width: 100%;
  min-width: 0;
  padding: 20px clamp(1.25rem, 4vw, 3.25rem) 3rem;
  overflow-y: auto;
  overflow-x: visible;
`

export const CatalogBleed = styled.div`
  width: 100%;
  padding-inline: 0.75rem;
  box-sizing: border-box;
  overflow: visible;
`

export const PageTitle = styled.h1`
  margin: 0;
  font-family: 'Chivo', sans-serif;
  font-size: clamp(2rem, 5vw, 3.25rem);
  font-weight: 400;
  letter-spacing: -0.02em;
  background: linear-gradient(to right, #88e700 0%, #ddff00 45%, #78bc28 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`

export const Title = styled.div`
  margin: 0;
  font-family: 'Chivo', sans-serif;
  font-size: clamp(2rem, 5vw, 2.25rem);
  font-weight: 400;
  letter-spacing: -0.02em;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 170px);
  min-width: 0;
  overflow: hidden;
`
